import React, { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import styled from "styled-components";
import { Outlet } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const Wrapper = styled.div`
  display: flex;
  min-height: 100vh;
`;

const Content = styled.div`
  flex: 1;
  padding: 16px;

  @media (min-width: 992px) {
    margin-left: 240px;
  }
`;

export default function Layout() {
  const [open, setOpen] = useState(false);
  const { authUser } = useAuth();

  return (
    <>
      <Header toggle={() => setOpen(!open)} />
      <Wrapper>
        <Sidebar open={open} close={() => setOpen(false)} role={authUser?.role} />
        <Content onClick={() => open && setOpen(false)}>
          <Outlet />
        </Content>
      </Wrapper>
    </>
  );
}